import DigitarDe from "@pages/DigitarDe/DigitarDe";

export default DigitarDe;
